<template>
    <div>
        <div class="popover-body p-0" v-for="(source, ind) in order.sources" :key="ind">
            <div class="popover-sub-title">
                <h6>{{(source.type === sectionType.DEPOT) ?
                   getGateName(source.gate_id, source.location_id) : source.details.name }}</h6>
            </div>
            <Form :inline="true" class="form-default form-multi">
            <FormItem :label="$t('INDENT_TRUCK_IN_DATE_TIME')" class="mb-0">
                <DatePicker
                v-model="source.arrived_at"
                type="datetime"
                :clearable="false"
                :format="datePickerFormat"
                :placeholder="$t('INDENT_PICK_DATE')"
                :picker-options="getPickerOptions(source)"
                size="small"
                />
            </FormItem>
            <FormItem :label="$t('INDENT_TRUCK_OUT_DATE_TIME')" class="mb-0">
                <DatePicker
                v-model="source.dispatched_at"
                :clearable="false"
                type="datetime"
                :format="datePickerFormat"
                :placeholder="$t('INDENT_PICK_DATE')"
                size="small"
                />
            </FormItem>
            </Form>
        </div>
        <div class="popover-footer pt-0 mt-15">
            <Button type="primary" size="mini" @click="showPopup">
            {{$t('INDENT_SUBMIT')}}
            </Button>
        </div>
        <div class="with-shadow no-border" placement="bottom" v-if="showAlertFlag">
          <div class="popover-body bg-white">
            <p class="mt-5 mb-0 text-sm text-bold">
              {{$t('TRUCK_DETAINED_CHECK',
              { n: this.truckDetainedConfig.no_of_day })}}
            </p>
          </div>
          <div class="popover-footer px-0 mx-20 py-10">
            <Button type="text" size="mini" class="text-grey-dark" @click="showAlertFlag=false">
              {{$t('INDENT_NO')}}
            </Button>
            <Button type="primary" size="mini" @click="updateTimestamp">
            {{$t('INDENT_YES_PROCEED')}}
            </Button>
          </div>
        </div>

    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';

export default {
  props: {
    order: {
      default: () => ({ }),
      type: Object,
    },
    datePickerFormat: {
      type: String,
      default: 'dd-MM-yyyy hh:mm A',
    },
    truckDetainedConfig: {
      default: () => ({
      }),
      type: Object,
    },
  },
  data() {
    return {
      sectionType: { DEPOT: 1 },
      showAlertFlag: false,
    };
  },
  computed: {
    ...mapGetters({
      currentUser: 'app/currentUser',
    }),
    gateList() {
      return this.order.sources.filter(this.hasDepotGates);
    },
  },
  methods: {
    hasDepotGates(source) {
      const hasGateAccess = (this.currentUser &&
      this.currentUser.gate_associates_ids) && this.currentUser.gate_associates_ids.length;
      return source.type === this.sectionType.DEPOT &&
      hasGateAccess ? this.currentUser.gate_associates_ids.includes(source.gate_id) : true;
    },
    getGateName(gateId, depotId) {
      const gateDeails = this.$depot.gate(gateId, depotId);
      return gateDeails && gateDeails.name;
    },
    computeDiffBetweenDays(startDay, endDay) {
      if (!startDay || !endDay) {
        return 0;
      }
      return moment(endDay).diff(moment(startDay), 'days');
    },
    showPopup() {
      const istruckDetainedConfigEnabled = this.truckDetainedConfig &&
       this.truckDetainedConfig.enabled;
      if (istruckDetainedConfigEnabled) {
        // compute diff of truck in and truck out and compare if greater than the configured n
        const isExceedThreshold = this.order.sources
          .filter(source => source.dispatched_at && source.arrived_at)
          .find(source => this.computeDiffBetweenDays(source.arrived_at, source.dispatched_at) >=
           this.truckDetainedConfig.no_of_day);
        if (isExceedThreshold) {
          this.showAlertFlag = true;
        }
      }
      if (!this.showAlertFlag) {
        this.updateTimestamp();
      }
    },
    async updateTimestamp() {
      this.showAlertFlag = false;
      try {
        if (this.order && this.order.sources && this.order.sources.length) {
          const orderNo = this.order.order_number;
          const payload = [];
          let arrivalGreater = false;
          this.order.sources.forEach((source) => {
            const arrivedAt = new Date(source.arrived_at);
            const dispatchAt = new Date(source.dispatched_at);
            if (arrivedAt.getTime() > dispatchAt.getTime()) {
              arrivalGreater = true;
            }
            const obj = {
              unique_id: source.unique_id,
              arrived_at: arrivedAt,
              dispatched_at: dispatchAt,
            };
            payload.push(obj);
          });
          if (arrivalGreater) {
            this.$error({ message: this.$t('INDENT_ARRIVAL_LESSER_DISPATCH_ERROR_MSG') });
            return;
          }
          const result = await this.$store.dispatch('order/updateTruckTimestamp', { payload, orderNo });
          if (result && result.data) {
            this.$success({ message: result.data });
            this.$emit('done', result.is_truckin_truckout_changed);
          } else {
            this.$error({ message: result.error });
          }
        }
      } catch (err) {
        throw err;
      }
    },
    getPickerOptions(source) {
      const dispatchedAt = new Date(this.$moment(source.dispatched_at)) || new Date();
      const createdAt = new Date(this.$moment(this.order.created_at));
      createdAt.setHours(0, 0, 0, 0);
      return {
        disabledDate(time) {
          return time.getTime() < createdAt.getTime() ||
          time.getTime() > dispatchedAt.getTime();
        },
      };
    },
  },
};
</script>
